var map = {
	"./emoticon-error.png": 60511,
	"./logo-empresa.png": 39693,
	"./parceiros/baladapp.png": 63124,
	"./parceiros/icone-generico.png": 20320,
	"./parceiros/mineirao.png": 99323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56709;